import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnDVRTimeChanged = (
    onDVRTimeChanged: (props: {
        startTime: number | undefined;
        endTime: number | undefined;
    }) => void
) => {
    useInstanceEffect(
        (instance) =>
            instance.onDVRTimeChanged(({ startTime, endTime }) =>
                onDVRTimeChanged({ startTime, endTime })
            ),
        [onDVRTimeChanged]
    );
};
